export const ControlTypesActivity1 = [
    {value: 'elektryczne 24V', label: 'elektryczne 24V'},
    {value: 'pneumatyczne – automaty', label: 'pneumatyczne – automaty'},
    {value: 'pneumatyczne ze skrzynkami alarmowymi', label: 'pneumatyczne ze skrzynkami alarmowymi'},
    {value: 'sterowanie 230V do wentylacji', label: 'sterowanie 230V do wentylacji'},
    {value: 'inne', label: 'inne'},
];

export default ControlTypesActivity1